import { Outlet, ScrollRestoration } from "react-router"

export function RootTemplate() {
  return (
    <>
      <Outlet />
      <ScrollRestoration />
    </>
  )
}
